import React, { useState } from 'react';
import { Cpu, Shield } from 'lucide-react';
import { agents } from '../data/content';

const AgentsSection = () => {
  const [activeTab, setActiveTab] = useState('system-analyst');

  const getTierColor = (tier) => {
    const colorMap = {
      'Core Agent': 'from-blue-500 to-cyan-500',
      'Specialist Agent': 'from-green-500 to-emerald-500',
      'Premium Agent': 'from-purple-500 to-violet-500',
      'Elite Agent': 'from-yellow-500 to-orange-500'
    };
    return colorMap[tier] || 'from-blue-500 to-purple-500';
  };

  return (
    <section id="agents" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-6">Meet Your AI Executive Team</h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Six specialized AI agents working in corporate hierarchy, from implementation to strategic oversight.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {Object.entries(agents).map(([key, agent]) => (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              className={`p-4 rounded-xl border transition-all duration-200 text-center group ${
                activeTab === key
                  ? 'bg-blue-600 border-blue-500 text-white shadow-lg scale-105'
                  : 'bg-slate-800 border-slate-700 text-slate-300 hover:border-slate-600 hover:scale-102'
              }`}
            >
              <div className="text-3xl mb-2 group-hover:animate-bounce">{agent.avatar}</div>
              <div className="font-semibold text-sm">{agent.name}</div>
              <div className="text-xs text-slate-400 mt-1">{agent.tier}</div>
            </button>
          ))}
        </div>

        <div className="bg-slate-800 border border-slate-700 rounded-2xl p-8 shadow-2xl">
          <div className="flex items-start space-x-6">
            <div className="text-6xl animate-float">{agents[activeTab].avatar}</div>
            <div className="flex-1">
              <div className="flex items-center space-x-4 mb-4">
                <h3 className="text-2xl font-bold text-white">{agents[activeTab].name}</h3>
                <span className={`bg-gradient-to-r ${getTierColor(agents[activeTab].tier)} text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg`}>
                  {agents[activeTab].tier}
                </span>
              </div>
              <p className="text-lg text-blue-300 mb-4 font-medium">{agents[activeTab].role}</p>
              <p className="text-slate-300 mb-6 leading-relaxed text-lg">{agents[activeTab].description}</p>
              <div className="mb-6">
                <h4 className="text-white font-semibold mb-3 text-lg">Key Capabilities:</h4>
                <div className="flex flex-wrap gap-2">
                  {agents[activeTab].capabilities.map((capability, index) => (
                    <span key={index} className="bg-slate-700/50 border border-slate-600 text-slate-300 px-4 py-2 rounded-full text-sm font-medium hover:bg-slate-600/50 transition-colors">
                      {capability}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex items-center space-x-6 text-sm text-slate-400">
                <div className="flex items-center space-x-2">
                  <Cpu className="h-4 w-4" />
                  <span>Proprietary AI Engine</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Shield className="h-4 w-4" />
                  <span>Enterprise Security</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentsSection;
